import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'dvrs',
  title: 'Видеорегистраторы',
  elemsOnPage: 100,
  apiType: apiTypes.REPORT_API,
  connections: {
    vehicle: {
      apiType: apiTypes.REPORT_API,
      table: 'vehicles',
      fields: ['depot_number'],
      format: (elem: any) => elem['name'],
      index: 'id',
      autocomplete: true,
    },
    dvr_types: {
      apiType: apiTypes.REPORT_API,
      table: 'dvr_types',
      fields: [],
      autocomplete: true,
      format: (elem: any) => elem['name'],
      index: 'id'
    },
    camera_types: {
      apiType: apiTypes.REPORT_API,
      table: 'camera_types',
      fields: [],
      autocomplete: true,
      format: (elem: any) => elem['name'],
      index: 'id'
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '70px',
      disableFilter: true
    },
    {
      name: 'vehicle_id',
      title: 'Гаражный номер ТС',
      type: 'number',
      required: true,
      connection: 'vehicle',
      id_type: 'number',
    },
    {
      name: 'dvr_type_id',
      title: 'Тип видеорегистратора',
      type: 'number',
      required: false,
      connection: 'dvr_types',
      id_type: 'number',
    },
    {
      name: 'serial_number',
      title: 'Серийный номер',
      type: 'text',
      required: false,
      maxLengthValue: 255
    },
    {
      name: 'ip',
      title: 'IP-адрес',
      type: 'text',
      required: false,
      validate: (value: any) =>
        /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/.test(value),
      validateError: 'Неверный формат IP-адреса',
      width: '130px'
    },
    {
      name: 'port',
      title: 'Порт',
      type: 'number',
      required: false,
      maxValue: 65535,
      minValue: 1,
      width: '70px',
    },
    {
      name: 'login',
      title: 'Логин',
      type: 'text',
      required: false,
      maxLengthValue: 255,
      width: '130px'
    },
    {
      name: 'password',
      title: 'Пароль',
      type: 'text',
      required: false,
      maxLengthValue: 255,
      width: '130px'
    },
    {
      name: 'media_server_ip',
      title: 'IP-адрес медиа-сервера',
      type: 'text',
      required: false,
      validate: (msValue: any) =>
        /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/.test(msValue),
      validateError: 'Неверный формат IP-адреса',
      width: '130px'
    },
    {
      name: 'media_server_port',
      title: 'Порт медиа-сервера',
      type: 'number',
      required: false,
      maxValue: 65535,
      minValue: 1,
      width: '70px',
    },
    {
      name: 'media_server_login',
      title: 'Логин медиа-сервера',
      type: 'text',
      required: false,
      maxLengthValue: 255,
      width: '130px'
    },
    {
      name: 'media_server_password',
      title: 'Пароль медиа-сервера',
      type: 'text',
      required: false,
      maxLengthValue: 255,
      width: '130px'
    },
    {
      name: 'is_media_server_use',
      title: 'Работа с медиа-сервером',
      type: 'boolean',
      required: false,
      disabled: false,
      conditions: [
        {
          condition: 'auto-set',
          value: 'inherited',
          viceVersaValue: 'meta-disable',
          priority: 1,                        // lower = higher priority
          dependens: [
            {
              name: 'msip',
              condition: 'is-not-empty'
            },
            {
              name: 'msport',
              condition: 'is-not-empty'
            },
            {
              name: 'mslogin',
              condition: 'is-not-empty'
            },
            {
              name: 'mspassword',
              condition: 'is-not-empty'
            }
          ]
        }
      ],
      width: '100px'
    },
    {
      name: 'cameras',
      title: 'Видеокамеры',
      type: 'cameraModal',
      connection: 'camera_types',
      disableFilter: true,
      disableSort: true,
      width: '100px'
    }
  ],
  newTemplate: {
    id: null,
    vehicle_id: null,
    type_code: null,
    serial_number: null,
    ip: null,
    port: null,
    login: null,
    password: null,
    media_server_ip: null,
    media_server_port: null,
    media_server_login: null,
    media_server_password: null,
    is_media_server_use: false
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'equipment_id',
        field: 'id',
      },
      {
        title: 'ip',
        field: 'ip',
      },
      {
        title: 'model_id',
        field: 'DevMNTType_id',
      },
      {
        title: 'login',
        field: 'login',
      },
      {
        title: 'password',
        field: 'password',
      },
      {
        title: 'port',
        field: 'port',
      },
      {
        title: 'vehicle_id',
        field: 'vehicle_id',
      },
      {
        title: 'msip',
        field: 'msip',
      },
      {
        title: 'mslogin',
        field: 'mslogin',
      },
      {
        title: 'mspassword',
        field: 'mspassword',
      },
      {
        title: 'msport',
        field: 'msport',
      },
      {
        title: 'msuse',
        field: 'msuse',
      }
    ],
    example: `1;127.0.0.1;00-14-22-01-23-45;admin;password;8080;1;127.0.0.1;user;password;8080;false`,
  },
};

export default config;
